export type InboundArrivalLogSubmitResult = {
  arrivalId: string;
  printed: number | null;
  printError: string | null;
};

export function inboundArrivalMissingPrinterError(): string {
  return "Arrival logged. Pick a label printer, then use Reprint on that row.";
}

export function inboundArrivalLoggedPrintError(detail: string): string {
  const trimmed = detail.trim();
  const printPart = trimmed === "" ? "Labels did not print." : `Labels did not print: ${trimmed}`;
  return `${printPart} Arrival is on the dock list. Use Reprint on that row.`;
}

/**
 * Always records the dock arrival first. Print failure does not create another
 * arrival: the modal closes and Reprint on the list is the retry.
 */
export async function runInboundArrivalLogAndPrint(options: {
  printer: string;
  logArrival: () => Promise<{ id: string; packageIds?: string[] }>;
  printLabels: (input: {
    arrivalId: string;
    printer: string;
    packageIds?: string[];
  }) => Promise<{ printed: number }>;
}): Promise<InboundArrivalLogSubmitResult> {
  const arrival = await options.logArrival();
  const printer = options.printer.trim();
  if (printer === "") {
    return {
      arrivalId: arrival.id,
      printed: null,
      printError: inboundArrivalMissingPrinterError(),
    };
  }
  try {
    const printed = await options.printLabels({
      arrivalId: arrival.id,
      printer,
      packageIds: arrival.packageIds,
    });
    return { arrivalId: arrival.id, printed: printed.printed, printError: null };
  } catch (printError) {
    const detail = printError instanceof Error ? printError.message : String(printError);
    return {
      arrivalId: arrival.id,
      printed: null,
      printError: inboundArrivalLoggedPrintError(detail),
    };
  }
}
